export const parentPermissionRecipientTypePatcher = (data) => {
    return {
        __typename: 'ParentPermissionRecipient',
        ...data,
    };
};
